import React from "react";
import { useLanguage } from "../context/LanguageContext";

const IMAGES = [
  {
    src: "https://static.wixstatic.com/media/952455_a44a3f64317f4b84aa2b5d14775e3ca2~mv2.jpg/v1/fill/w_800,h_534,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — performance",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://static.wixstatic.com/media/952455_767596813995450b9913aa5129b2cca2~mv2.jpg/v1/fill/w_800,h_417,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — string ensemble",
  },
  {
    src: "https://static.wixstatic.com/media/952455_ebd3ed374c794205a23397575b7693b5~mv2.jpg/v1/fill/w_800,h_359,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — concert",
  },
  {
    src: "https://static.wixstatic.com/media/952455_e92ba3d8d6a44408b00d677d93c67e07~mv2.jpg/v1/fill/w_800,h_534,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — chamber",
  },
  {
    src: "https://static.wixstatic.com/media/952455_efb07ec02ece48749583476c1e675299~mv2.jpg/v1/fill/w_800,h_534,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — recital",
    span: "lg:col-span-2",
  },
  {
    src: "https://static.wixstatic.com/media/952455_17c12d3d0c5f41ee9919721c54e12ef8~mv2.jpeg/v1/fill/w_800,h_600,al_c,q_85/file.jpeg",
    alt: "Proscenio Ensemble — soprano",
  },
  {
    src: "https://static.wixstatic.com/media/952455_77e3f0d8e30b4ee6bc56cc320a094835~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — clarinet",
  },
  {
    src: "https://static.wixstatic.com/media/952455_f2374fb3c8bd4dd08ddc2ebfd7a74ef0~mv2.jpg/v1/fill/w_800,h_724,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — concert hall",
  },
  {
    src: "https://static.wixstatic.com/media/952455_466bad538f1543d180baeb91e6fa9e51~mv2.jpg/v1/fill/w_800,h_720,al_c,q_85/file.jpg",
    alt: "Proscenio Ensemble — formation",
    span: "lg:col-span-2",
  },
];

export const Galleria = () => {
  const { t } = useLanguage();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-28 lg:py-36 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-16">
          <div className="overline" data-testid="gallery-overline">
            {t.gallery.overline}
          </div>
          <h2
            data-testid="gallery-title"
            className="font-serif-display font-light mt-5 text-4xl md:text-5xl lg:text-6xl text-[#FDFBF7] leading-[1.05]"
          >
            {t.gallery.title}
          </h2>
          <p className="mt-6 text-[#A1A1AA] text-base lg:text-lg font-light leading-relaxed">
            {t.gallery.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4 auto-rows-[180px] lg:auto-rows-[220px]">
          {IMAGES.map((img, i) => (
            <div
              key={i}
              data-testid={`gallery-image-${i}`}
              className={`relative overflow-hidden border border-white/10 group ${
                img.span || ""
              }`}
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-1000"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Galleria;
